import { render } from "./ChartLegend.vue?vue&type=template&id=396d6554"
import script from "./ChartLegend.vue?vue&type=script&lang=js"
export * from "./ChartLegend.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__